import { render, staticRenderFns } from "./RoundtableViewDetails.vue?vue&type=template&id=d2cf0cb2&"
import script from "./RoundtableViewDetails.vue?vue&type=script&lang=js&"
export * from "./RoundtableViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoundtableViewDetails.vue?vue&type=style&index=0&id=d2cf0cb2&prod&lang=scss&"
import style1 from "./RoundtableViewDetails.vue?vue&type=style&index=1&id=d2cf0cb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports